import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import styles from './CheckEmailPage.module.css';

interface LocationState {
  email?: string;
}

const CheckEmailPage: React.FC = () => {
  const location = useLocation();
  const state = location.state as LocationState | null;
  const email = state?.email;

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.iconWrap}>
          <span className={styles.icon}>✉</span>
        </div>

        <h1 className={styles.title}>Check your inbox</h1>

        <p className={styles.text}>
          An access link has been sent to{' '}
          {email ? (
            <span className={styles.email}>{email}</span>
          ) : (
            'your email'
          )}
        </p>

        <div className={styles.badge}>
          The link expires in 15 minutes
        </div>

        <p className={styles.muted}>
          Also check your spam folder
        </p>

        <Link to="/members" className={styles.backLink}>
          Back
        </Link>
      </div>
    </div>
  );
};

export default CheckEmailPage;
